export const planningQuestions = [
  "Is this patient an appropriate candidate for the proposed approach?",
  "Which biomechanical principles are relevant to this case?",
  "What should guide archwire selection?",
  "How will anchorage requirements influence treatment planning?",
  "Which movements should be prioritized?",
  "What limitations must be considered?",
  "When should treatment progress be reassessed?",
  "How should finishing and retention be planned?",
];

export const roadmapSteps = [
  { number: "01", title: "ASSESS", text: "Evaluate the patient, diagnostic findings, treatment objectives, and clinical limitations." },
  { number: "02", title: "SELECT", text: "Understand the characteristics of active and passive self-ligating systems and the considerations involved in bracket selection." },
  { number: "03", title: "PLAN", text: "Connect archwire properties, biomechanics, movement objectives, and anchorage requirements." },
  { number: "04", title: "SEQUENCE", text: "Organize the proposed treatment into logical clinical phases." },
  { number: "05", title: "MONITOR", text: "Review treatment progress, identify deviations, and recognize situations requiring reassessment." },
  { number: "06", title: "FINISH", text: "Understand finishing objectives, retention considerations, and post-treatment review." },
];

export const beforeItems = [
  "You understand bracket mechanics but struggle to connect them with complete treatment planning.",
  "You review multiple references to understand archwire characteristics and clinical applications.",
  "You find it difficult to distinguish between the biomechanical principles of active and passive systems.",
  "You sometimes focus on appliance selection before fully defining treatment objectives.",
  "You want a clearer way to organize anchorage, sequencing, and monitoring.",
  "You have clinical information scattered across textbooks, lectures, and personal notes.",
];

export const afterItems = [
  "You have an organized reference for understanding self-ligating systems.",
  "You can review biomechanical concepts through visual explanations.",
  "You understand the clinical considerations behind archwire selection.",
  "You can organize treatment objectives and anchorage requirements.",
  "You have structured worksheets for reviewing treatment phases.",
  "You can revisit one educational roadmap instead of searching through disconnected materials.",
];

export const painPoints = [
  {
    title: "You use self-ligating brackets but want a deeper understanding of the biomechanics involved.",
    text: "You know the appliance, but you want to connect its mechanical characteristics with the broader treatment plan.",
  },
  {
    title: "You're unsure how different archwire properties influence clinical decisions.",
    text: "You understand the importance of archwire selection but want a more organized way to study the relevant variables.",
  },
  {
    title: "You want to understand active versus passive self-ligation beyond marketing claims.",
    text: "You need a clinically grounded explanation of their differences, limitations, and available evidence.",
  },
  {
    title: "You sometimes struggle to connect anchorage requirements with planned tooth movements.",
    text: "You want to understand how these factors interact before evaluating a treatment sequence.",
  },
  {
    title: "You want a clearer framework for reviewing treatment progress.",
    text: "You need a structured way to identify whether observed changes align with planned objectives.",
  },
  {
    title: "You want to study self-ligating orthodontics without jumping between dozens of disconnected resources.",
    text: "You need a coherent educational reference that brings the major concepts together.",
  },
];

export const concepts = [
  "Bracket design",
  "Slot dimensions",
  "Friction and resistance to sliding",
  "Archwire materials",
  "Force systems",
  "Anchorage",
  "Tooth movement",
  "Finishing mechanics",
];

export const authorQuestions = [
  "What do I need to understand about the appliance?",
  "What patient-specific factors matter?",
  "Which biomechanical principles are relevant?",
  "How do treatment objectives influence sequencing?",
  "What potential problems require attention?",
  "How should finishing and retention be considered?",
];

export const finalFlow = [
  "Self-Ligating Fundamentals",
  "Clinical Assessment",
  "Archwire Biomechanics",
  "Anchorage & Treatment Sequencing",
  "Troubleshooting",
  "Finishing & Retention",
];
